export class Author {
  id: number = 0;
  name: string = '';
  slugUrl: string = '';
  bio: string = '';
  image: string = '';
}
